<template>
  <div class="animated fadeIn">

    <div class="row">
      <div class="col-9">
        <h4><i class="fa fa-trophy"></i><span class="ml-1">Gratification Recharges</span></h4>
      </div>

      <div class="col-2">
        <h4>
          <span> True Failure </span>
          <label class="switch switch-outline-primary" >
            <input type="checkbox" class="switch-input" v-model="true_failure"  value=false
                   unchecked-value=true  @change="trueFailure">
            <span class="switch-slider"></span>
          </label>
        </h4>
      </div>
    </div>


    <div class="card">
      <v-client-table :data="recharges" :columns="columns" :options="options">
        <template slot="user_name" slot-scope="props">
          <div>
              <span>
                  {{props.row.user.name}}
              </span>
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'SendGratification', params: {id: props.row.id}}">
              <span
                  class="btn btn-primary btn-sm m-1"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="View"
              >
                <CIcon name="cil-magnifying-glass" size="sm" />
              </span>
            </router-link>
          </div>
        </template>

      </v-client-table>
    </div>


  </div>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "GratificationRecharges",
  data() {
    return {
      expand_column: false,
      true_failure: false,
      recharges: [],
      tempRecharges: [],
      balance: "",
      date: new Date(),
      type: "",
      columns:["action", "user_name","msisdn", "status", "type","gratification_type","source_name","amount", "operator_short","created_at"],
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["created_at"],
        dateFormat: 'DD-MM-YYYY hh:mm:ss',
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },

  created() {
    this.getList();
  },
  methods: {
    getList() {
      axios
          .get(`${ADMIN_URL}/recharge-data-list`)
          .then((response) => {
            this.recharges = response.data;
            this.recharges.forEach(function (element) {
              element.source_name =(element.tournament)? element.tournament.name:'';
            });
            this.tempRecharges = this.recharges;
          })
          .catch((error) => {
            console.log(error);
          });
    },

    trueFailure(e){
      if(!this.true_failure){
        return this.recharges = this.tempRecharges
      }
      // this.tempRecharges = this.recharges
      // let succeedPhone = []
      // this.recharges.filter((item) => {
      //   console.log(item);
      //   if(item.status == 'SUCCEED'){
      //     succeedPhone.push(item.msisdn)
      //   }
      // })

      this.recharges = this.recharges.filter((item) => {
        if(item.status!='SUCCEEDED' || item.hasError==1) {
          console.log('status', item.status, 'error', item.hasError)
          return true;
        }
      })
    },


  }
}
</script>

<style scoped>

</style>
